<template>
  <div>
    <AppHeader />
    <main class="min-h-[calc(100vh-3.5rem)] bg-[var(--ui-bg)]">
      <UContainer class="py-6">
        <slot />
      </UContainer>
    </main>
  </div>
</template>
